// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hCiYt3fJnOA-rJ {\n  background: #FFFFFF;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  padding: 12px 28px 12px 24px;\n  position: relative;\n}\n.gbHDSYg0vKZX2N {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n}\n._1jNriX4G8t8lo5 {\n  background-color: #5AAC44;\n  box-shadow: 0 1px 0 0 #3F6F21;\n  line-height: 20px;\n  margin-top: 8px;\n  margin-right: 4px;\n  padding: 6px 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "hCiYt3fJnOA-rJ",
	"greeting": "gbHDSYg0vKZX2N",
	"button": "_1jNriX4G8t8lo5"
};
export default ___CSS_LOADER_EXPORT___;
